"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisualizationType = exports.VisualizationTypes = void 0;
/**
 * @internal
 */
exports.VisualizationTypes = {
    BAR: "bar",
    COLUMN: "column",
    LINE: "line",
    PIE: "pie",
    DONUT: "donut",
    TABLE: "table",
    HEADLINE: "headline",
    AREA: "area",
    SCATTER: "scatter",
    BUBBLE: "bubble",
    HEATMAP: "heatmap",
    GEO: "geo",
    PUSHPIN: "pushpin",
    COMBO: "combo",
    COMBO2: "combo2",
    HISTOGRAM: "histogram",
    BULLET: "bullet",
    TREEMAP: "treemap",
    WATERFALL: "waterfall",
    FUNNEL: "funnel",
    PARETO: "pareto",
    ALLUVIAL: "alluvial",
    XIRR: "xirr",
};
/**
 * @internal
 */
function getVisualizationType(type) {
    if (type === exports.VisualizationTypes.COMBO2) {
        return exports.VisualizationTypes.COMBO;
    }
    return type;
}
exports.getVisualizationType = getVisualizationType;
//# sourceMappingURL=visualizationTypes.js.map